<div class="panel">
  <div class="veiculo__header">
    <div></div>
    <h3>Veículo
      <span *ngIf="isPesados">{{ descricao }}</span>
    </h3>
    <ng-content></ng-content>
  </div>
  <p class="border">{{veiculo.descricao}}</p>
  <div class="veiculo__actions">
    <a
      (click)="onClickAlterar()"
      *ngIf="veiculo.descricao">
      alterar
    </a>
    <a
      (click)="onClickRemover()"
      *ngIf="veiculo.descricao && canRemoveVeiculo()">
      remover
    </a>
  </div>
</div>

<app-modal-message #modalMessage title="Atenção"></app-modal-message>
